import * as React from "react";
import { ISelectListItem } from "./ISelectListItem";
import { Icon } from "../Icon/icon";

export interface ISiteFunctionsProps {
  minorityLanguage?: string;
  siteMapUrl: string;
  easyread?: string;
  signlanguage?: string;
  translatedStartpage?: string;
  translatedstartpageText?: string;
  minorityLanguages: ISelectListItem[];
  translatedItems: ISelectListItem[];
  translatedStartPageItems: ISelectListItem[];
  signlanguageText: string;
  easyreadText: string;
}

export class SiteFunctions extends React.Component<ISiteFunctionsProps> {
  render() {
    return (
      <div className="site-menu__functions">
        <div className="site-menu__functions-header">
          {this.props.minorityLanguage &&
            this.props.minorityLanguage.length > 0 && (
              <a
                href={this.props.minorityLanguage}
                className="site-menu__function-item"
                lang="en"
              >
                <Icon iconType="fontawesome/globe-europe" />
                <span className="functionlink__text">Other languages</span>
              </a>
            )}

          {this.props.translatedStartpage &&
            this.props.translatedStartpage.length > 0 && (
              <a
                href={this.props.translatedStartpage}
                className="site-menu__function-item"
                lang="en"
              >
                {this.props.translatedstartpageText === "English" && (
                  <Icon
                    className="functionlink__isEnglish"
                    iconType="fontawesome/language-eng"
                  />
                )}
                {this.props.translatedstartpageText === "Swedish" && (
                  <Icon
                    className="functionlink__isEnglish"
                    iconType="fontawesome/language-se"
                  />
                )}
                <span className="functionlink__text">
                  {this.props.translatedstartpageText}
                </span>
              </a>
            )}

          {this.props.signlanguage && (
            <a
              href={this.props.signlanguage}
              className="site-menu__function-item"
            >
              <Icon iconType="fontawesome/sign-language" />
              <span className="functionlink__text">
                {this.props.signlanguageText}
              </span>
            </a>
          )}
          {this.props.easyread && (
            <a href={this.props.easyread} className="site-menu__function-item">
              <Icon iconType="fontawesome/language-lattlast" />
              <span className="functionlink__text">
                {this.props.easyreadText}
              </span>
            </a>
          )}
        </div>
        {(this.props.translatedItems &&
          this.props.translatedItems.length > 0) ||
          (this.props.translatedStartPageItems &&
            this.props.translatedStartPageItems.length > 0) ||
          (this.props.minorityLanguages &&
            this.props.minorityLanguages.length > 0 && (
              <ul className="site-menu__language-expander">
                {(this.props.translatedItems || []).map((lang) => (
                  <li key={lang.Value}>
                    <a href={lang.Value}>Go to {lang.Text}</a>
                  </li>
                ))}

                {(this.props.translatedStartPageItems || []).map((lang) => (
                  <li key={lang.Value}>
                    <a href={lang.Value}>Go to {lang.Text} startpage</a>{" "}
                  </li>
                ))}

                {this.props.minorityLanguages.map((lang) => (
                  <li key={lang.Value}>
                    <a href={lang.Value}>Go to {lang.Text}</a>
                  </li>
                ))}
              </ul>
            ))}
      </div>
    );
  }
}
